module.exports = __webpack_public_path__ + "img/img6.1656e667.png";